import { Box } from '@wishket/design-system';

import { HeadLineListSkeleton } from '../HeadLineList';

import { SummaryTitle } from '@/features/Author';
import { FadeUpContainer } from '@/shared/Components';
import { useAuthorArticleQuery } from '@/entities/author';
import EmptyContent from '@/features/EmptyContent';
import { ArticleColumnItem } from '@/features/Article';

const MAXIMUM_ARTICLES = 3;

interface AuthorArticlesProps {
  authorId: number;
  onClickSeeAll?: () => void;
  authorName?: string;
  articleType: 'new' | 'popular';
}

const AuthorArticles = ({
  authorId,
  onClickSeeAll,
  authorName = '',
  articleType,
}: AuthorArticlesProps) => {
  const ordering = articleType === 'new' ? 'latest' : 'popular';
  const { data, isLoading } = useAuthorArticleQuery({
    authorId,
    ordering: ordering,
    pageSize: MAXIMUM_ARTICLES,
  });

  const isEmpty = data?.articles.length === 0;

  if (isLoading)
    return (
      <Box className="px-5 desktop:px-0">
        <HeadLineListSkeleton />
      </Box>
    );

  return (
    <Box className="flex w-full flex-col gap-8">
      <Box className="px-5 desktop:px-0">
        {articleType === 'new' && (
          <SummaryTitle
            title="새로 올라온 콘텐츠"
            icon="fire"
            onClickSeeAll={onClickSeeAll}
          />
        )}
        {articleType === 'popular' && (
          <SummaryTitle
            title="인기 콘텐츠"
            nickname={authorName}
            onClickSeeAll={onClickSeeAll}
          />
        )}
      </Box>
      {!data || isEmpty ? (
        <EmptyContent title="콘텐츠가 없어요." />
      ) : (
        <FadeUpContainer
          className="-mt-5 flex w-dvw gap-5 overflow-y-hidden overflow-x-scroll px-5 pt-5 scrollbar-hide tablet:grid tablet:auto-cols-fr tablet:grid-cols-3 desktop:w-full desktop:gap-6 desktop:px-0"
          itemClassName="w-full"
          delay={0.2}
        >
          {data.articles.map((article) => {
            return (
              <Box
                key={String(article.id)}
                className="w-[210px] shrink-0 tablet:w-full"
                id={`author-article-item--${article.id}`}
                data-gtm-id="author-article-item"
              >
                <ArticleColumnItem {...article} isSimplified />
              </Box>
            );
          })}
        </FadeUpContainer>
      )}
    </Box>
  );
};

export default AuthorArticles;
